import { useQuery } from "@tanstack/react-query";
import { Button } from "antd";
import { FormattedMessage, useIntl } from "react-intl";
import { pdfSVG, printButtonSVG } from "../../../../assets/SVGs/SVGs";
import { showSale } from "../../../../network/Sales";
import { downloadPDF } from "../../../../utils/DownloadPdf";
import { handlePrint } from "../../../../utils/HandlePrint";
import Invoice from "../../ReservationReceipt";

const LastStep = ({ idSale, locationId }: any) => {
  const { data: saleData, isLoading } = useQuery(["sales"], () =>
    showSale(locationId, idSale)
  );
  const intl = useIntl();
  const data = Array.isArray(saleData?.data)
    ? saleData?.data[0]
    : saleData?.data;

  return (
    <div className="flex flex-col items-center justify-center w-full">
      <h5 className="py-3 mb-6 text-base text-color-primary font-semibold rounded-lg bg-[#FBFBFF]">
        <FormattedMessage id="sale_number" defaultMessage={`Sale`} />#{idSale}
      </h5>
      <div className="flex flex-col items-center justify-center w-full gap-4 mb-12">
        <span className="flex items-center text-base font-semibold text-center text-green-600">
          {intl.formatMessage({
            id: "operation_successful",
            defaultMessage: "Successfully completed",
          })}
        </span>
        <svg
          width="89"
          height="106"
          viewBox="0 0 89 106"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M81.3216 1.95886C80.1637 0.806683 78.3111 0.806683 77.269 1.95886L73.4479 5.76103L69.7427 2.07407C68.5848 0.921901 66.7322 0.921901 65.69 2.07407L61.869 5.76103L58.1637 2.07407C57.1216 1.03712 55.1532 1.03712 54.1111 2.07407L50.2901 5.76103L46.5848 2.07407C45.4269 0.921901 43.5743 0.921901 42.5322 2.07407L38.7111 5.76103L35.0058 2.07407C34.4269 1.49799 33.7322 1.15234 32.9216 1.15234C32.1111 1.15234 31.4164 1.49799 30.8374 1.95886L27.1322 5.76103L23.4269 2.07407C22.269 0.921901 20.4164 0.921901 19.3743 2.07407L15.5532 5.76103L11.8479 2.07407C10.69 0.921901 8.83742 0.921901 7.79531 2.07407L2.00584 7.83494C1.42689 8.41103 1.19531 9.10234 1.19531 9.90886V96.3219C1.19531 97.1284 1.54268 97.8197 2.00584 98.3958L7.79531 104.157C8.95321 105.309 10.8058 105.309 11.8479 104.157L15.5532 100.239L19.2585 103.926C20.4164 105.078 22.269 105.078 23.3111 103.926L27.1322 100.239L30.8374 103.926C31.8795 104.963 33.8479 104.963 34.89 103.926L38.7111 100.239L42.4164 103.926C43.5743 105.078 45.4269 105.078 46.469 103.926L50.2901 100.239L53.9953 103.926C54.5743 104.502 55.269 104.733 56.0795 104.733C56.89 104.733 57.5848 104.387 58.1637 103.926L61.869 100.239L65.5743 103.926C66.7322 105.078 68.5848 105.078 69.6269 103.926L73.4479 100.239L77.1532 103.926C77.7321 104.502 78.4269 104.733 79.2374 104.733C80.0479 104.733 80.7427 104.502 81.3216 103.926L87.1111 98.1654C87.69 97.5893 87.9216 96.898 87.9216 96.0915V9.67842C87.9216 8.8719 87.5743 8.1806 87.1111 7.60451L81.3216 1.95886ZM85.4611 95.0545L79.2374 102.904L75.5322 99.2168C74.9532 98.5254 74.1427 98.295 73.4479 98.295C72.7532 98.295 71.9427 98.5254 71.3637 99.1015L67.6585 102.904L63.9532 99.2168C62.7953 98.0646 60.9427 98.0646 59.9006 99.2168L56.0795 102.904L52.3743 99.2168C51.7953 98.6407 51.1006 98.295 50.2901 98.295C49.4795 98.295 48.7848 98.6407 48.2058 99.1015L44.5006 102.904L40.7953 99.2168C39.7532 98.1798 37.7848 98.1798 36.7427 99.2168L32.9216 102.904L29.2164 99.2168C28.0585 98.0646 26.2058 98.0646 25.1637 99.2168L21.3427 102.904L17.6374 99.2168C16.4795 98.0646 14.6269 98.0646 13.5848 99.2168L9.76373 102.904L3.54005 95.0545V10.9458L9.76373 3.09663L13.469 6.78359C14.6269 7.93576 16.4795 7.93576 17.5216 6.78359L21.3427 3.09663L25.0479 6.78359C26.2058 7.93576 28.0585 7.93576 29.1006 6.78359L32.9216 3.09663L36.6269 6.78359C37.2058 7.35967 37.9006 7.59011 38.7111 7.59011C39.5216 7.59011 40.2164 7.24445 40.7953 6.78359L44.5006 3.09663L48.2058 6.78359C49.2479 7.82054 51.2164 7.82054 52.2585 6.78359L56.0795 3.09663L59.7848 6.78359C60.9427 7.93576 62.7953 7.93576 63.8374 6.78359L67.6585 3.09663L71.3637 6.78359C72.5216 7.93576 74.3743 7.93576 75.4164 6.78359L79.2374 3.09663L85.4611 10.9458V95.0545Z"
            fill="#479821"
          />
          <path
            d="M52.7852 68.2582L50.7935 70.1159L42.4284 77.9715L38.2744 74.0968L37.7622 73.6191C37.1932 73.0883 36.2827 73.0883 35.7705 73.6191C35.2015 74.1499 35.2015 74.9991 35.7705 75.4768L41.461 80.7847C41.7456 81.0501 42.087 81.1562 42.4853 81.1562C42.8837 81.1562 43.2251 81.0501 43.5096 80.7847L54.8906 70.169C55.4597 69.6382 55.4597 68.7889 54.8906 68.3112C54.2647 67.7805 53.3542 67.7805 52.7852 68.2582Z"
            fill="#479821"
          />
          <path
            d="M13.8076 28.1562H38.5666C39.557 28.1562 40.3351 27.4275 40.3351 26.5C40.3351 25.5725 39.557 24.8438 38.5666 24.8438H13.8076C12.8172 24.8438 12.0391 25.5725 12.0391 26.5C12.0391 27.4275 12.8172 28.1562 13.8076 28.1562Z"
            fill="#479821"
          />
          <path
            d="M13.9413 39.75H36.7684C37.8337 39.75 38.6706 39.0213 38.6706 38.0938C38.6706 37.1663 37.8337 36.4375 36.7684 36.4375H13.9413C12.8761 36.4375 12.0391 37.1663 12.0391 38.0938C12.0391 39.0213 12.8761 39.75 13.9413 39.75Z"
            fill="#479821"
          />
          <path
            d="M37.0062 49.6875C37.0062 48.76 36.0907 48.0312 34.9256 48.0312H14.1197C12.9545 48.0312 12.0391 48.76 12.0391 49.6875C12.0391 50.615 12.9545 51.3438 14.1197 51.3438H34.9256C36.0907 51.3438 37.0062 50.615 37.0062 49.6875Z"
            fill="#479821"
          />
          <path
            d="M54.9019 48.0312H50.7407C49.5756 48.0312 48.6602 48.76 48.6602 49.6875C48.6602 50.615 49.5756 51.3438 50.7407 51.3438H54.9019C56.0671 51.3438 56.9825 50.615 56.9825 49.6875C56.9825 48.76 56.0671 48.0312 54.9019 48.0312Z"
            fill="#479821"
          />
          <path
            d="M51.9895 36.4375H48.6606C47.7285 36.4375 46.9961 37.1663 46.9961 38.0938C46.9961 39.0213 47.7285 39.75 48.6606 39.75H51.9895C52.9216 39.75 53.654 39.0213 53.654 38.0938C53.654 37.1663 52.9216 36.4375 51.9895 36.4375Z"
            fill="#479821"
          />
          <path
            d="M50.3255 24.8438H46.9965C46.0644 24.8438 45.332 25.5725 45.332 26.5C45.332 27.4275 46.0644 28.1562 46.9965 28.1562H50.3255C51.2576 28.1562 51.9899 27.4275 51.9899 26.5C51.9899 25.5725 51.2576 24.8438 50.3255 24.8438Z"
            fill="#479821"
          />
        </svg>
      </div>
      <div className="flex items-center justify-between w-full gap-4">
        <Button
          type="default"
          onClick={() => handlePrint(<Invoice data={data} />)}
          className="border-color-primary cursor-pointer flex items-center justify-center w-full text-center border-solid border-[1px] px-6 py-2 bg-white rounded-lg"
        >
          <div className="flex items-center gap-2 font-semibold text-color-primary">
            {printButtonSVG}
            <span className="text-sm">
              {intl.formatMessage({
                id: "print",
              })}
            </span>
          </div>
        </Button>
        <Button
          type="default"
          onClick={() => downloadPDF(<Invoice data={data} />, data?.id)}
          className="border-color-primary cursor-pointer flex items-center justify-center w-full text-center border-solid border-[1px] px-6 py-2 bg-white rounded-lg"
        >
          <div className="flex items-center gap-2 font-semibold text-color-primary">
            {pdfSVG}
            <span className="text-sm">
              {intl.formatMessage({
                id: "downloadPDF",
              })}
            </span>
          </div>
        </Button>
      </div>
    </div>
  );
};

export default LastStep;
